import FuseUtils from '@fuse/utils/FuseUtils';
import axios from 'axios';
import { createECDH } from '@ravshansbox/browser-crypto';
import { logout, setUser } from 'app/store/userSlice';
// @ts-ignore
import store from 'app/store';
import { api } from 'app/store/api/api';
import { decode } from 'msgpack-lite';
/* eslint-disable camelcase */
import history from '@history';

const curve = 'secp256k1';

const publicKey = createECDH(curve).generateKeys('base64');

class JwtService extends FuseUtils.EventEmitter {
  init() {
    this.setInterceptors();
    this.handleAuthentication();
  }

  setInterceptors = () => {
    const instance = axios.create({
      baseURL: process.env.REACT_APP_API_ROOT,
    });
    // @ts-ignore

    instance.interceptors.response.use(
      (response) => {
        const ctype = response.headers['content-type'];
        if (ctype.includes('charset=ISO-8859-1')) {
          response.data = decode(response.data, 'ISO-8859-1');
        }
        return response;
      },
      (error) => {
        const originalRequest = error.config;
        if (error?.response?.status === 401 && !error.config?._isRetry) {
          originalRequest._isRetry = true;
          try {
            api()
              .post(
                '/get-user',
                {},
                {
                  headers: {
                    Authorization: `Bearer ${JSON.parse(localStorage.getItem('refresh_token'))}`,
                  },
                },
              )
              .then((res) => {
                console.log(res);
                // const { access_token, refresh_token } = res.data.data;
                // localStorage.setItem("access_token", JSON.stringify({ access_token }));
                // localStorage.setItem("refresh_token", JSON.stringify({ refresh_token }));
                // return instance.request(originalRequest);
              })
              .catch((err) => {
                console.log(err);
                localStorage.removeItem('access_token');
              });
          } catch (e) {
            console.error('NOT_AUTHORIZED');
          }
        }
        throw error;
      },
    );

    instance.interceptors.request.use(
      (config) => {
        // Здесь можете сделать что-нибудь с перед отправкой запроса
        return config;
      },
      (error) => {
        console.log(error);
        // Сделайте что-нибудь с ошибкой запроса
        return Promise.reject(error);
      },
    );

    return instance;
  };

  handleAuthentication = () => {
    const access_token = this.getAccessToken();
    const refresh_token = this.getRefreshToken();

    if (!access_token) {
      this.emit('onNoAccessToken');
    }

    if (!access_token || access_token.length < 10) {
      if (refresh_token) {
        api()
          .post(`auth/get-session`, {
            curve,
            public_key: publicKey,
          })
          .then((res) => {
            if (res.data.id) {
              this.signInWithToken(res.data.id);
            }
          })
          .catch((err) => console.log(err));
      }
    }

    if (this.isAuthTokenValid(access_token)) {
      this.setSession(access_token, refresh_token);
      this.emit('onAutoLogin', true);
    } else {
      this.setSession(null);
      // this.emit('onAutoLogout', 'access_token expired');
    }
  };

  signInWithSSOCode = (code, SSO_CLIENT_ID) => {
    console.log('1234567890765432146', process.env);
    return new Promise((resolve, reject) => {
      api()
        .post(`auth/get-session`, { curve, public_key: publicKey })
        .then((res) => {
          const { id } = res.data;
          api()
            .post(`auth/get-token`, {
              client_id: SSO_CLIENT_ID,
              session_id: id,
              code,
            })
            .then((response) => {
              if (response.data.user) {
                this.setSession(
                  response.data.access_token,
                  response.data.refresh_token,
                  response.data.user,
                );
                resolve(response.data.user);
                this.emit('onLogin', response.data.user);
              } else {
                reject(response.data.error);
              }
            });
        })
        .catch((err) => console.log(err));
    });
  };

  // eslint-disable-next-line consistent-return
  getUser = async () => {
    const access_token = this.getAccessToken();
    if (access_token) {
      try {
        const response = await api().post(`auth/get-user`, {
          access_token,
        });

        const roles =
          response.data.roles_names || response.data.permissions
            ? response.data.roles_names || response.data.permissions
            : response.data.roles_names || response.data.permissions;

        await store.dispatch(
          setUser({
            role: roles,
            data: response.data,
            isLogged: true,
          }),
        );

        return response.data;
      } catch (error) {
        console.log(error);
      }
    } else {
      const res = await api().post(`auth/get-session`, {
        curve,
        public_key: publicKey,
      });

      if (res.data.id) {
        this.signInWithToken(res.data.id);
      }

      return {};
    }
  };

  // eslint-disable-next-line consistent-return
  signInWithToken = async () => {
    const res = await api().post(`auth/get-session`, {
      curve,
      public_key: publicKey,
    });
    const { id } = res.data;
    if (res.data.id) {
      return new Promise((resolve, reject) => {
        const refresh_token = this.getRefreshToken();
        api()
          .post(`auth/get-refresh-token`, {
            refresh_token,
            client_id: process.env.REACT_APP_SSO_CLIENT_ID,
            session_id: id,
          })
          .then((response) => {
            if (response.data.user) {
              this.setSession(
                response.data.access_token,
                response.data.refresh_token,
                store.dispatch(
                  setUser({
                    role: response.data.user.roles_names,
                    data: response.data.user,
                    isLogged: true,
                  }),
                ),
              );
              // window.location.reload();
              resolve(response.data.user);
            } else {
              // this.logout();
              this.setSession(null);
              console.log('Failed to login with token.');
              reject(new Error('Failed to login with token.'));
              // history.push('/sign-in');
            }
          })
          .catch((error) => {
            console.log(error);
            localStorage.clear();
            history.push('/sign-in');
            // window.location.reload();
            this.logout();
            // reject(new Error('Failed to login'));
          });
      });
    }
  };

  setSession = (access_token, refresh_token, user) => {
    if (refresh_token) {
      localStorage.setItem('refresh_token', refresh_token);
    }
    if (user?.roles_names) {
      localStorage.setItem('user_role', JSON.stringify(user.roles_names));
    }
    if (access_token) {
      localStorage.setItem('access_token', access_token);

      axios.defaults.headers.common.Authorization = `Bearer ${access_token}`;
    } else {
      localStorage.clear();
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      localStorage.removeItem('user_role');
      store.dispatch(logout());
      delete axios.defaults.headers.common.Authorization;
    }
  };

  logout = () => {
    this.setSession(null);
    this.emit('onLogout', 'Logged out');
  };

  isAuthTokenValid = (access_token) => {
    if (!access_token) {
      return false;
    }
    // const decoded = jwtDecode(access_token);
    // const currentTime = Date.now() / 1000;
    // if (decoded.exp < currentTime) {
    //   console.warn('access token expired');
    //   return false;
    // }

    return true;
  };

  getAccessToken = () => {
    return window.localStorage.getItem('access_token');
  };

  getRefreshToken = () => {
    return window.localStorage.getItem('refresh_token');
  };
}

const instance = new JwtService();

export default instance;
